import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuGameRulesStyles/SudokuGameRules.css';
import GameControls from '../../../../../../Assets/images/GameRulesImages/InGameControls.png';
import { useLanguage } from 'Core/Translations/LanguageContext';

const GameRules = () => {
    const { t } = useLanguage();

    return (
        <div className="notification-container">
            <p className="notification-text">
                🚨<strong>{t.beginnersGuide.gameRules.notification.important}</strong>
                {t.beginnersGuide.gameRules.notification.text}
            </p>

            <div className="game-rules-container">
                {/* Left Column: Rules */}
                <div className="rules-section">
                    <h2>{t.beginnersGuide.gameRules.rulesHeader}</h2>
                    <ol>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule1_pre}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule1_strong}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule1_post}
                        </li>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule2_pre}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule2_strong}</strong>
                        </li>
                        <li>{t.beginnersGuide.gameRules.rulesList.rule3}</li>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule4_pre1}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule4_strong1}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule4_pre2}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule4_strong2}</strong>
                        </li>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule5_pre}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule5_strong}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule5_post}
                        </li>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule6_pre}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule6_strong}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule6_post}
                        </li>
                        <li>
                            {t.beginnersGuide.gameRules.rulesList.rule7_pre}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule7_strong_pre}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule7_pre2}
                            <strong>{t.beginnersGuide.gameRules.rulesList.rule7_strong_post}</strong>
                            {t.beginnersGuide.gameRules.rulesList.rule7_post}
                        </li>
                        <li>{t.beginnersGuide.gameRules.rulesList.rule8}</li>
                    </ol>

                    <div className="rules-warning">
                        {t.beginnersGuide.gameRules.rulesWarning}
                    </div>
                </div>

                {/* Right Column: Game Controls + Scoring (stacked) */}
                <div className="controls-and-scoring">
                    <div className="controls-section">
                        <h2>{t.beginnersGuide.gameRules.gameControls.header}</h2>
                        <img
                            src={GameControls}
                            alt="Game Controls Visual"
                            className="controls-image"
                        />
                        <ol>
                            <li>
                                {t.beginnersGuide.gameRules.gameControls.list.control1_pre}
                                <strong>{t.beginnersGuide.gameRules.gameControls.list.control1_strong}</strong>
                                {t.beginnersGuide.gameRules.gameControls.list.control1_post}
                            </li>
                            <li>
                                {t.beginnersGuide.gameRules.gameControls.list.control2_pre}
                                <strong>{t.beginnersGuide.gameRules.gameControls.list.control2_strong}</strong>
                                {t.beginnersGuide.gameRules.gameControls.list.control2_post}
                            </li>
                            <li>
                                {t.beginnersGuide.gameRules.gameControls.list.control3_pre}
                                <strong>{t.beginnersGuide.gameRules.gameControls.list.control3_strong}</strong>
                                {t.beginnersGuide.gameRules.gameControls.list.control3_post}
                            </li>
                        </ol>
                    </div>

                    <div className="scoring-section">
                        <h2>{t.beginnersGuide.gameRules.scoring.header}</h2>
                        <ul>
                            <li>
                                {t.beginnersGuide.gameRules.scoring.list.score1_pre1}
                                <strong>{t.beginnersGuide.gameRules.scoring.list.score1_strong1}</strong>
                                {t.beginnersGuide.gameRules.scoring.list.score1_pre2}
                                <span className="correct">{t.beginnersGuide.gameRules.scoring.list.score1_span}</span>
                                {t.beginnersGuide.gameRules.scoring.list.score1_post}
                            </li>
                            <li>
                                {t.beginnersGuide.gameRules.scoring.list.score2_pre1}
                                <strong>{t.beginnersGuide.gameRules.scoring.list.score2_strong1}</strong>
                                {t.beginnersGuide.gameRules.scoring.list.score2_pre2}
                                <span className="incorrect">{t.beginnersGuide.gameRules.scoring.list.score2_span}</span>
                                {t.beginnersGuide.gameRules.scoring.list.score2_post}
                            </li>
                            <li>
                                {t.beginnersGuide.gameRules.scoring.list.score3_pre1}
                                <strong>{t.beginnersGuide.gameRules.scoring.list.score3_strong1}</strong>
                                {t.beginnersGuide.gameRules.scoring.list.score3_pre2}
                                <span className="solved">{t.beginnersGuide.gameRules.scoring.list.score3_span}</span>
                                {t.beginnersGuide.gameRules.scoring.list.score3_post}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameRules;